function ProductGridItemsInit(e){
  var currentProduct = e.attr("data-value");
  var currentVariant = e.attr("value");
  var $currentProductLabel = $("span[data-product="+ currentProduct +"]");
  var $currentProductPrice = $("span[data-product-price="+ currentProduct +"]");
  var $currentProductImage = $("img[data-product="+ currentProduct +"]");
  var $currentProductLink = $("a[data-product="+ currentProduct +"]");

  var $option = $("select[name=id][data-value="+ currentProduct +"] option").each(function(i){
    var $currentOption = $(this);

    if ($(this).val() == currentVariant) {
      $currentProductLabel.text($(this).text());
      $currentProductPrice.text('From: $' + $(this).attr("data-variant-price"));
      $currentProductLink.attr("href", $(this).attr("data-product-url"));
      $currentProductImage.fadeOut(200, function(){
        $(this).attr("src", $currentOption.attr("data-variant-img"));
        $(this).fadeIn();
      });
      $(this).attr("selected", "selected" );
    } else {
      $(this).removeAttr("selected")
    }
  });
};
function hideColumns(index) {
  var select = document.getElementById(`columnSelect-${index}`);
  var $content_list = $(`.content div[data-index="${index}"]`);
  // console.log($content_list)
  
  var products_container = document.getElementById(`comparison-products-${index}`);
  var divElements = products_container.getElementsByClassName("product");
  
  var selectedIndex = select.selectedIndex;
  var numRows = 5;

  // Hide all columns
  $content_list.each(function() {
    $(this).children().each(function( index ) {
      // console.log($(this));
      if (selectedIndex == index) {
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
    });
  });
  //Hide all products
  for (var i = 0; i < divElements.length; i++) {
    if (selectedIndex == i) {
      divElements[i].classList.remove("hidden");
    } else {
      divElements[i].classList.add("hidden");
    }
  }
}